<div class="filter" (click)="onRemove()">
  <span *ngIf="type === 'DATE'; else notDate">{{ displayStr | date: PIPE_DATE_FORMAT }}</span>
  <ng-template #notDate>
    <span>
      <ng-container *ngIf="preTagForDataDisplay; else noPreTag">
        <pre>{{ displayStr.toString() | translate }}</pre>
      </ng-container>
      <ng-template #noPreTag>
        {{ displayStr.toString() | translate }}
      </ng-template>
    </span>
  </ng-template>
  <img class="filter-img" src="assets/common/cross.svg" />
</div>
